define('metric',["require", "exports", "./util/cookie", "./util/log"], function (require, exports, cookie_1, log) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Set metric mode
     */
    function setMetric(metric) {
        if (metric) {
            cookie_1.default.set("BASELINE_METRIC", "true", 365);
        }
        else {
            cookie_1.default.unset("BASELINE_METRIC");
        }
        // Reload page
        setTimeout(function () { window.location.reload(); }, 100);
    }
    // Initialize signed in user
    var checkbox = document.getElementById("metric-checkbox");
    // Set current state
    if (checkbox && cookie_1.default.get("BASELINE_METRIC")) {
        checkbox.checked = true;
    }
    // Handle clicks
    var metricLink = document.getElementById("metric-link");
    if (metricLink) {
        metricLink.addEventListener("click", function () {
            metricLink.blur();
            checkbox.checked = !checkbox.checked;
            setMetric(checkbox.checked);
            log.info(checkbox.checked ? "metric" : "imperial");
            return false;
        });
    }
});
//# sourceMappingURL=/assets/javascripts/metric.js.map;
